// extracted by mini-css-extract-plugin
module.exports = {"highlightLight":"F-text-highlight-highlight-light-3hETU","highlightDark":"F-text-highlight-highlight-dark-1Eg71"};